import { useMemo } from 'react';
import { View } from 'react-native';
import { useSelector } from 'react-redux';
import { Text } from '@ui-kitten/components';
import lodashIsEqual from 'lodash/isEqual';

import { selectIsDayHasCart } from '../../../RTK/mealPlan/selectors';
import themeStyle from '../../../Theme/styles';

import Button from '../../Button';

import { BreadcrumbsDay, BreadcrumbsProps } from './types';

type BreadcumbsItemProps = Pick<BreadcrumbsProps, 'onClick' | 'value'> & {
  item: BreadcrumbsDay;
};

const BreadcumbsItem = ({ item, value, onClick }: BreadcumbsItemProps) => {
  const hasCart = useSelector((state) =>
    selectIsDayHasCart(state, [item?.value]),
  );
  const hasOnClick = typeof onClick === 'function';
  const isDisabled = !hasCart && value !== item.value;
  const Wrapper = hasOnClick ? Button : View;
  const conditionWrapperProps = useMemo(() => {
    if (!hasOnClick) return {};
    return {
      plain: true,
      onPress: () => {
        if (!isDisabled) {
          onClick(item);
        }
      },
    };
  }, [isDisabled, item, hasOnClick, onClick]);
  return (
    <Wrapper
      style={[
        themeStyle.flex1,
        themeStyle.pageVerticalSpacingMedium,
        themeStyle.pageHorizontalSpacingSmall,
      ]}
      {...conditionWrapperProps}
    >
      <Text
        appearance={isDisabled ? 'hint' : 'default'}
        numberOfLines={1}
        status={lodashIsEqual(value, item.value) ? 'success' : 'basic'}
        style={themeStyle.textCenter}
      >
        {item.label}
      </Text>
    </Wrapper>
  );
};

export default BreadcumbsItem;
